import { Injectable } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';

import { PageViewType, TrackingData } from '@hdms/shared/common-types';

import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class BaseTrackingDto {
  private readonly updateSubject = new ReplaySubject<TrackingData>(1);

  constructor(private readonly env: EnvironmentService) {
    if (!env.isStandalone) {
      // when in legacy hybris mode, pass on trackingData added via hdms environment
      this.updateSubject.next(env.trackingData);
    }
  }

  /**
   * In standalone mode, invoked when loggedInContext is received, so that
   * base tracking data can be enriched with user-related data.
   * @param initialTrackingData
   */
  updateData(initialTrackingData: TrackingData): void {
    if (this.env.isStandalone) {
      this.updateSubject.next({
        webSiteType: 'www',
        pageviewType: PageViewType.USER_INITIATED,
        mobileApp: this.env.mobileApp,
        country: this.env.country,
        region: this.env.hub,
        pageLanguage: this.env.languageTagLong,
        ...initialTrackingData
      });
    }
  }

  update$(): Observable<TrackingData> {
    return this.updateSubject.asObservable();
  }
}
